import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, ChevronRight, PlayCircle } from "lucide-react";
import { Button } from "../ui/button";
import { useS } from "../../lib/simple";

export function WorkCard({ items }) {
  const { s } = useS();
  const nav = useNavigate();
  const [first, ...rest] = items;
  return (
    <div className="beam p-[1px]" data-testid="home-work-card">
      <div className="rounded-[1.2rem] bg-[var(--lb-card)] p-5 sm:p-6">
        <p className="inline-flex items-center gap-2 text-xs font-bold tracking-wide text-neon uppercase"><PlayCircle size={15} /> {s("work_title")}</p>
        <h2 className="font-display font-black text-xl sm:text-2xl leading-tight mt-3" data-testid="home-work-title">{first.title}</h2>
        <p className="text-sm text-[hsl(var(--muted-foreground))] mt-1">{first.sub}</p>
        <Button onClick={() => nav(first.to)} data-testid="home-work-continue" className="w-full sm:w-auto sm:px-8 mt-5 rounded-full h-14 bg-gradient-to-r from-primary to-neon text-white lb-glow-btn font-semibold text-base">
          {s("cont")} <ArrowRight size={18} className="ml-1.5" />
        </Button>
        {rest.length > 0 && (
          <div className="mt-5 pt-4 border-t border-white/5 space-y-1">
            {rest.map((it) => (
              <button key={it.key} onClick={() => nav(it.to)} data-testid={`home-work-${it.key}`}
                className="w-full flex items-center gap-3 text-left min-h-[52px] px-3 rounded-xl hover:bg-white/5 transition-colors">
                <div className="min-w-0 flex-1">
                  <p className="text-sm font-medium truncate">{it.title}</p>
                  <p className="text-xs text-[hsl(var(--muted-foreground))]">{it.sub}</p>
                </div>
                <ChevronRight size={16} className="text-[hsl(var(--muted-foreground))] shrink-0" />
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
